import { ForwardedRef, MutableRefObject, useEffect, useRef } from 'react'

export const useMixedRef = <T>(outterRef?: ForwardedRef<T>) => {
  const innerRef = useRef<T>()
  return outterRef || innerRef
}

export const useAwaitForRefMutable = (ref: MutableRefObject<any>, callback: () => void) => {
  // console.log('SETS AWAIT', ref)

  const tId = useRef<NodeJS.Timeout>()
  clearTimeout(tId.current)
  const setSpeyRef = () => {
    tId.current = setTimeout(() => {
      // console.log('is it ref yet?', ref)

      if (ref.current) {
        clearTimeout(tId.current)
        callback()
      } else {
        setSpeyRef()
      }
    }, 500)
  }
  setSpeyRef()
}

export const useCssImporter = (filePaths: string[]) => {
  useEffect(() => {
    if (filePaths?.length > 0) {
      filePaths.forEach(src => {
        const link = window.document.createElement('link')
        link.rel = 'stylesheet'
        link.type = 'text/css'
        link.href = src
        window.document.head.appendChild(link)
      })
    }
  }, [filePaths])
}
